module.exports = __webpack_public_path__ + "static/media/Camera1.4a218a6c.jpg";